import http from '@/utils/http'
import MD5 from 'crypto-js/md5'
import Base64 from 'crypto-js/enc-base64'
import Utf8 from 'crypto-js/enc-utf8'

export function login(authority) {
	let authorityRequest = {...authority}
	authorityRequest.password = Base64.stringify(Utf8.parse(MD5(authority.password).toString()))
	return http.post('/api/authority/login', authorityRequest)
}

export function autoLogin(weixinId) {
	return http.post('/api/authority/weixin/autoLogin', {weixinId: weixinId})
}

export function logout() {
	return http.post('/api/authority/logout', null, {
		ignoreToken: true
	})
}

export function refresh(refreshToken) {
	return http.post('/api/authority/token', {
		refreshToken: refreshToken
	}, {
		ignoreToken: true
	})
}

export function getInfo(token) {
	return http.get('/api/authority/info', {
		params: {
			token
		}
	})
}

// 保存用户头像
export function modifyAvatar(avatar) {
	return http.put('/api/users/avatar', avatar)
}

export function weixinLogin(code) {
	return http.post('/api/authority/weixin/login', {
		code: code
	})
}

export function registerUser(data) {
	return http.post('/api/authority/weixin/users', data)
}

export function unBindUser() {
	return http.put('/api/authority/weixin/unBindUser')
}

export function selectSmsValidateCode(data) {
	return http.post('/api/authority/weixin/selectSmsValidateCode', data)
}
